import React, { useMemo } from "react";
import {
  CssBaseline,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material";
import "./App.css";

import StepperProvider from "./contexts/stepper.context";
import { createMuiTheme } from "./Theme";
import * as locales from "@mui/material/locale";
import { useIntl } from "react-intl";
import Stepper from "./components/stepper.component";
import Banner from "./components/banner.component";

function App() {
  const intl = useIntl();

  const lang = useMemo(() => {
    switch (intl.locale) {
      case "fr":
        return locales["frFR"];
      case "en":
        return locales["enUS"];
      case "de":
        return locales["deDE"];
    }
  }, [intl]);

  const muiTheme = useMemo(
    () => createMuiTheme("light", lang ?? locales["frFR"]),
    [lang]
  );

  return (
    <div className="App">
      <MuiThemeProvider theme={muiTheme}>
        <StepperProvider>
          <CssBaseline enableColorScheme />

          <Banner />
          <main className="main">
            <Stepper />
          </main>
        </StepperProvider>
      </MuiThemeProvider>
    </div>
  );
}

export default App;
